import { FilterChip } from "@components/common/faro-table/faro-table-filter/filter-chip";
import { FilterChipDropdownItem } from "@components/common/faro-table/faro-table-filter/filter-chip-dropdown-item";
import { getSizeRangeFilterId, parseSizeRangeFilterId } from "@components/projects/projects-filters/projects-size-filter-utils";
import { SizeCustomRange } from "@components/projects/projects-filters/size-filter/size-custom-range";
import { ChevronRightIcon, Menu, MenuItem, MenuSeparator } from "@flat-ui";
import { useFilterQueryParams } from "@hooks/table-filters/use-filter-query-params";
import { Box, Stack } from "@mui-wrapper";
import { PALETTE_VARS } from "@styles/palette-vars";
import { useState } from "react";

/** Width of the dropdown, which fits the fields of the custom range */
const DROPDOWN_WIDTH = "280px";
/**
 * A chip to filter by a size. It offers fixed sizes and lets the user type a custom range, kept in
 * the URL as e.g. "range:500MB_2GB". Only one of them is applied at a time.
 */
export function SizeFilterChip({
  filteredColumn,
  label,
  presets,
  tableType
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isCustomRangeShown, setIsCustomRangeShown] = useState(false);
  const {
    getFilterIdsForColumn,
    updateFilterItem
  } = useFilterQueryParams();
  const activeFilterId = getFilterIdsForColumn(filteredColumn).at(0);
  const activeRange = activeFilterId === undefined ? undefined : parseSizeRangeFilterId(activeFilterId);

  /** Applies the filter, or removes it if it was the applied one */
  function toggleFilter(filterId) {
    updateFilterItem({
      tableType,
      filteredColumn,
      filterId,
      shouldReplaceFilterInColumn: true
    });
  }

  /** Applies the custom range, or removes the applied one if the user emptied both limits */
  function applyCustomRange(range) {
    const filterId_0 = range ? getSizeRangeFilterId(range) : activeFilterId;
    if (filterId_0 !== undefined && (!range || filterId_0 !== activeFilterId)) {
      toggleFilter(filterId_0);
    }
    closeDropdown();
  }
  function closeDropdown() {
    setAnchorEl(null);
    setIsCustomRangeShown(false);
  }
  return <Box component="div">
      <FilterChip filteredColumn={filteredColumn} label={label} shouldHaveDropdown={true} isDropdownOpen={!!anchorEl} onClick={event => setAnchorEl(event.currentTarget)} />

      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={closeDropdown} minWidth={DROPDOWN_WIDTH}
    // The unit dropdowns open their menus outside of this one, which must not take the focus back
    disableEnforceFocus slotProps={{
      paper: {
        sx: {
          width: DROPDOWN_WIDTH
        }
      }
    }}>
        {isCustomRangeShown ? <SizeCustomRange activeRange={activeRange} onBack={() => setIsCustomRangeShown(false)} onCancel={closeDropdown} onApply={applyCustomRange} /> : [...Object.values(presets).map(preset => <FilterChipDropdownItem key={preset.id} filterItem={preset} isItemSelected={preset.id === activeFilterId} onItemClicked={toggleFilter} shouldShowCheckbox={false} shouldShowCheckIconOnRight={true} shouldAllowLabelTranslation={true} />), <MenuSeparator key="separator" />, <MenuItem key="customRange" disableRipple selected={activeRange !== undefined} onClick={() => setIsCustomRangeShown(true)}>
              <Stack direction="row" sx={{
          flex: 1,
          alignItems: "center",
          justifyContent: "space-between",
          color: activeRange ? "primary.main" : "inherit"
        }}>
                Custom range...
                <ChevronRightIcon sx={{
            fontSize: "1rem",
            color: PALETTE_VARS.text.secondary
          }} />
              </Stack>
            </MenuItem>]}
      </Menu>
    </Box>;
}